// ─── Hook ─────────────────────────────────────────────────────────────────────

import type { GetApiV1ExamCorrectionGridExampublishidQueryParams } from '@/shared/api/generated';
import { useGetApiV1ExamCorrectionGridExampublishid } from '@/shared/api/generated';

/**
 * Hook para carregar os detalhes de uma resposta a ser corrigida.
 *
 * @param examPublishId - ID da publicação do exame (null desabilita a query)
 * @param params - Parâmetros opcionais de filtro e paginação (examItemId, pageNumber, pageSize)
 * @returns Dados da grade de correção com estado de loading/error
 *
 * @example
 * ```tsx
 * const { answer, isLoading } = useAnswerInfo(examPublishId, { examItemId: 1 });
 * ```
 */
export function useAnswerInfo(
  examPublishId: number | null,
  params?: GetApiV1ExamCorrectionGridExampublishidQueryParams,
) {
  const query = useGetApiV1ExamCorrectionGridExampublishid(examPublishId ?? 0, params, {
    query: { enabled: examPublishId !== null },
  });

  return {
    answer: query.data,
    // `isPending` (não `isLoading`) — `isLoading` do TanStack Query é `isPending &&
    // isFetching`, então ao alternar `enabled` (ex.: abrir o accordion) há uma janela
    // em que a busca ainda não começou (`isFetching` false) mas já não há dado
    // (`isPending` true); nessa janela `isLoading` reporta `false` e o componente
    // piscaria o empty state antes do conteúdo real chegar.
    isLoading: query.isPending,
    isError: query.isError,
  } as const;
}
